import React from 'react';

export default function Fishbowl() {
	// 7
	let style = {
		st66: {
 			opacity:0.5,
			fill:"#5994C9"
		},
		st67: {
 			fill:"#F9914B"
		},
		st0: {
 			fill:"#FFFFFF"
		},
		st68: {
 			fill:"#555555"
		},
		st69: {
 			opacity:0.3,
			fill:"#FFFFFF"
		}
	};
	return (
		<g>
			<path style={style.st66} d="M83.5136719,385.0002441c3.7431641,7.6689453,10.0224609,13.8703613,17.6806641,17.6125488
				c15.9580078,7.7973633,33.1171875,7.2277832,47.0810547-1.4890137
				c13.5556641-8.4638672,21.6484375-22.8986816,21.6484375-38.8581543c0-6.8554688-1.5588379-13.7131348-4.442627-19.8356934
				c-5.9592285-2.2416992-6.123291-3.6081543-12.9769287-3.6081543c-7.1300049,0-7.1300049,4-14.2598877,4
				c-7.1325684,0-7.1325684-4-14.2648926-4c-7.130249,0-7.130249,4-14.260498,4c-7.1350098,0-7.1350098-4-14.2700195-4
				c-6.8990479,0-6.9050293,1.4040527-12.9753418,3.6538086C76.371582,355.2243652,76.5168457,370.6643066,83.5136719,385.0002441z"/>
			<path style={style.st67} d="M141.2979889,368.9460144c0.6156616,0.6939087,0.603714,1.7212219-0.0278931,2.4006653
				c-2.3450775,2.5226135-8.3907928,8.1771851-15.401825,8.0957031c-9.0197601-0.1048279-16.221611-9.6637268-16.221611-9.6637268
				s7.4220581-9.3889465,16.4418182-9.2841187C133.0995026,360.5760193,139.0121765,366.3695679,141.2979889,368.9460144z"/>
			<path style={style.st67} d="M105.5564423,360.7468567l10.0445709,7.6731262
				c0.9468307,0.7232666,0.9301987,2.1542969-0.0331802,2.8553772l-10.2201843,7.4375916
				c-1.1848373,0.8622742-2.845932,0.0045166-2.8289032-1.4607544l2.3633881-7.7606201l-2.1877747-7.3500977
				C102.7113876,360.6762085,104.3919678,359.8572998,105.5564423,360.7468567z"/>
			<circle style={style.st0} cx="128.8622131" cy="369.7176208" r="4.4635382"/>
			<circle style={style.st68} cx="128.8622131" cy="369.7176208" r="1.949445"/>
			<path style={style.st0} d="M173.9191895,362.078125c0-13.9956055-5.9326172-27.2741699-16.2773438-36.7214355L157.0686035,325
				H90.8752441l-0.5732422,0.3566895c-16.9560547,15.4863281-20.9424438,39.5030518-10.296936,61.3145752
				C83.7018433,394.2454834,90,400.5063477,97,404.71875V408c0,3.3137207,3.0620117,6,7.0629883,6h39.8444824
				C147.9084473,414,151,411.3137207,151,408v-4l-0.0646973,0.0581055
				C165.2862549,394.8039551,173.9191895,379.1757812,173.9191895,362.078125z M148.270752,401.0820312
				c-13.9638672,8.7167969-31.1230469,9.2446289-47.0810547,1.4472656c-7.6582031-3.7421875-13.9375-9.8601074-17.6806641-17.5290527
				C73.7805176,365.067627,77.2971191,343,92.435791,329h63.0722656c9.1679688,8,14.4111328,20.6262207,14.4111328,33.244873
				C169.9191895,378.2043457,161.826416,392.6181641,148.270752,401.0820312z"/>
			<circle style={style.st69} cx="137.1647034" cy="355.0555725" r="2.7896991"/>
			<circle style={style.st69} cx="145.8713837" cy="350.9161987" r="3.5551238"/>
			<circle style={style.st69} cx="143.5653076" cy="360.9291992" r="1.8513534"/>
		</g>
	);
}



// WEBPACK FOOTER //
// ./src/components/Global/Goodies/Toy/Fishbowl.js